import React from 'react';
import { Carousel } from 'antd-mobile';
import { appMethod as app, appInstance } from '@utils/app';
import * as customEvent from '@utils/customEvent';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './SeckillDetail.less';

export default class SeckillDetail extends OfficialPage {
  state = {
    topNavBarData: {
      isDefault: 0,
      title: '秒杀详情'
    },
    goodsId: '',
    goodsInfo: {},
    modelStrs: {},
    selectModelInfo: {
      models: [],
      stock: '',
      price: '',
      virtualPrice: '',
      buyCount: 1,
      models_text: ''
    },
    pageQRCodeData: {
      shareDialogShow: '100%',
      shareMenuShow: false
    },
    commentArr: [],
    commentNums: [],
    commentExample: '',
    commentPage: 1,
    commnetType: 0,
    commentTotalPage: '',
    defaultPhoto: '',
    allStock: '',
    addToShoppingCartHidden: true,
    ifAddToShoppingCart: true,
    priceDiscountStr: '',
    page_hidden: true,
    appointmentPhone: '',
    detailCommetType: 'detail',
    carouselCurrentIndex: 1,
    imageOrVideo: 'image',
    storeStyle: ''
  }

  constructor(props) {
    super(props);
    document.title = '秒杀详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var goodsId = options.id || options.detail,
      seckill_activity_id =
        options.seckill_activity_id || options.sec_act_id || 0,
      seckill_activity_time_id =
        options.seckill_activity_time_id || options.sec_t_id || 0,
      seckillType = options.seckillType || options.secType || 0,
      contact = options.contact || '',
      franchiseeId = options.franchisee || '',
      cartGoodsNum = options.cart_num || 0,
      defaultPhoto = app.getDefaultPhoto(),
      goodsType = options.goodsType || 0,
      userToken = options.user_token || '',
      hidestock = options.hidestock || '',
      isShowVirtualPrice = options.isShowVirtualPrice || ''
    this.setData({
      goodsId: goodsId,
      seckill_activity_id: seckill_activity_id,
      seckill_activity_time_id: seckill_activity_time_id,
      seckillType: seckillType,
      contact: contact,
      defaultPhoto: defaultPhoto,
      franchiseeId: franchiseeId,
      cartGoodsNum: cartGoodsNum,
      goodsType: goodsType,
      isSeckill: true,
      hidestock: hidestock == 'true' ? true : false,
      isShowVirtualPrice: isShowVirtualPrice == 'true' ? true : false,
      'topNavBarData.totalHeight': app.globalData.topNavBarHeight || 0,
      sessionFrom: options.franchisee || app.getAppId() || ''
    })
    this.dataInitial()
    if (userToken) {
      app.globalData.PromotionUserToken = userToken
    }
    // TODO this.videoContext = app.createVideoContext('goodsDetail-video')
  }

  onReachBottom = () => {
    if (
      this.data.detailCommetType == 'comment' &&
      this.data.commentPage <= this.data.commentTotalPage
    ) {
      this.getAssessList(this.data.commentType, this.data.commentPage, 1)
    }
  }
  dataInitial = () => {
    var that = this
    if (!this.data.franchiseeId) {
      this.getAppECStoreConfig()
    }
    let data = {}
    if (this.data.seckillType == 1) {
      data = {
        data_id: this.data.goodsId,
        sub_shop_app_id: this.data.franchiseeId,
        is_seckill: 1,
        seckill_activity_arr: {
          seckill_activity_id: this.data.seckill_activity_id,
          seckill_activity_time_id: this.data.seckill_activity_time_id
        },
        is_seckill_activity: this.data.seckillType
      }
    } else {
      data = {
        data_id: this.data.goodsId,
        sub_shop_app_id: this.data.franchiseeId,
        is_seckill: 1,
        is_seckill_activity: this.data.seckillType
      }
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/getGoods',
      data: data,
      method: 'post',
      success: that.modifyGoodsDetail,
      complete: function () {
        that.setData({
          page_hidden: false
        })
      }
    })
  }
  onShareAppMessage = () => {
    this.setData({
      pageQRCodeData: {
        shareDialogShow: '100%',
        shareMenuShow: false
      }
    })
    let that = this,
      goodsId = this.data.goodsId,
      contact = this.data.contact,
      franchiseeId = this.data.franchiseeId,
      cartGoodsNum = this.data.cart_num || '',
      isSeckill = this.data.isSeckill,
      title = this.data.goodsInfo.share_title,
      shareImage = this.data.goodsInfo.share_image
        ? this.data.goodsInfo.share_image
        : this.data.goodsInfo.img_urls && this.data.goodsInfo.img_urls[0]
          ? this.data.goodsInfo.img_urls[0]
          : this.data.goodsInfo.cover,
      urlSeckill = isSeckill ? '&goodsType=seckill' : '',
      urlPromotion = app.globalData.PromotionUserToken
        ? '&user_token=' + app.globalData.PromotionUserToken
        : '',
      path =
        '/seckill/pages/seckillDetail/seckillDetail?id=' +
        goodsId +
        '&contact=' +
        contact +
        (franchiseeId
          ? '&franchisee=' + franchiseeId + '&cart_num=' + cartGoodsNum
          : '') +
        urlSeckill +
        urlPromotion +
        '&seckill_activity_id=' +
        that.data.seckill_activity_id +
        '&seckill_activity_time_id=' +
        that.data.seckill_activity_time_id +
        '&seckillType=' +
        that.data.seckillType
    return app.shareAppMessage({
      path: path,
      title: title,
      imageUrl: shareImage,
      success: function (addTime) {
        app.showToast({ title: '转发成功', duration: 500 })
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=appShop/getIntegralLog',
          data: { add_time: addTime },
          success: function (res) {
            if (res.status == 0) {
              res.data &&
                that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                })
            }
          }
        })
      }
    })
  }

  componentWillUnmount() {
    if (this.downcount) {
      this.downcount.clear()
    }
  }

  goToMyOrder = () => {
    var franchiseeId = this.data.franchiseeId,
      pagePath =
        '/eCommerce/pages/myOrder/myOrder?goodsType=' +
        this.data.goodsInfo.goods_type +
        '&currentIndex=0' +
        (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath, true)
  }
  goToShoppingCart = () => {
    var franchiseeId = this.data.franchiseeId,
      pagePath =
        '/eCommerce/pages/shoppingCart/shoppingCart' +
        (franchiseeId ? '?franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath, true)
  }
  goToHomepage = () => {
    let that = this
    let franchiseeId = that.data.franchiseeId
    let chainId = app.getChainId()
    if (franchiseeId && franchiseeId != chainId) {
      let pages = app.getCurrentPages()
      let p = pages[pages.length - 2]
      if (p && p.route == 'franchisee/pages/goodsMore/goodsMore') {
        app.turnBack({ delta: 2 })
      } else {
        customEvent.clickEventHandler['to-franchisee']({
          'franchisee-id': franchiseeId
        })
      }
    } else {
      var router = app.getHomepageRouter()
      app.reLaunch({ url: '/pages/' + router + '/' + router })
    }
  }
  goToCommentPage = () => {
    var franchiseeId = this.data.franchiseeId,
      pagePath =
        '/eCommerce/pages/goodsComment/goodsComment?detail=' +
        this.data.goodsId +
        (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  goodsCoverOnload = e => { }
  modifyGoodsDetail = res => {
    var _this = this,
      goods = res.data[0].form_data,
      unitType =
        (goods.appointment_info && goods.appointment_info.unit_type) || '',
      description = goods.description,
      goodsModel = [],
      selectModels = [],
      modifySelectModels = '',
      modelStrs = {},
      price = 0,
      discountStr = '',
      allStock = 0,
      selectStock,
      selectPrice,
      selectModelId,
      matchResult,
      selectVirtualPrice,
      selectText = '',
      selectImgurl = '',
      appointment_desc,
      appointmentPhone
    this.setData({
      unitType: unitType,
      appointmentDesc:
        goods.appointment_info && goods.appointment_info.appointment_desc
          ? goods.appointment_info.appointment_desc.replace(/<br \/>/g, '\r\n')
          : '更多优惠资讯详情请联系商家!',
      appointmentPhone:
        goods.appointment_info && goods.appointment_info.appointment_phone
          ? goods.appointment_info.appointment_phone
          : '',
      displayComment:
        goods.appointment_info && goods.appointment_info.display_comment == '1'
          ? goods.appointment_info.display_comment
          : ''
    })
    // makePhone: WxParse.wxParse(
    //   'wxParseDescription',
    //   'html',
    //   description,
    //   _this,
    //   10
    // )
    for (var key in goods.model) {
      if (key) {
        var model = goods.model[key]
        goodsModel.push(model)
        if (model && model.subModelName) {
          if (key == '1' && goods.goods_type == '1') {
            for (var index in model.subModelName) {
              var adjustTime = model.subModelName[index].split('-'),
                submodel = model.subModelName[index].substring(6, 8),
                endHours =
                  submodel - 24 >= 10 ? submodel - 24 : '0' + (submodel - 24)
              model.subModelName[index] =
                submodel >= 24
                  ? adjustTime[0] +
                  '-' +
                  '次日' +
                  endHours +
                  ':' +
                  adjustTime[1].split(':')[1]
                  : adjustTime[0] + '-当日' + adjustTime[1]
            }
          }
          if (goods.goods_type == '1' && model.id == '0') {
            for (var index in model.subModelName) {
              model.subModelName[index] =
                model.subModelName[index] +
                (goods.appointment_info && goods.appointment_info.unit)
            }
          }
          modelStrs[model.id] = model.subModelName.join('、')
          selectModels.push(model.subModelId[0])
          modifySelectModels = selectModels.toString()
          selectText += '“' + model.subModelName[0] + '” '
        }
      }
    }
    if (goods.model_items.length) {
      var items = goods.model_items
      for (let i = 0; i < items.length; i++) {
        let seckill_price = +items[i].seckill_price
        let modifyGoodsmodelseckill = items[i].model
        goods.seckill_highPrice =
          goods.seckill_highPrice >= seckill_price
            ? goods.seckill_highPrice
            : seckill_price
        goods.seckill_lowPrice =
          goods.seckill_lowPrice <= seckill_price
            ? goods.seckill_lowPrice
            : seckill_price
        allStock += Number(items[i].seckill_stock)
        if (modifyGoodsmodelseckill == modifySelectModels) {
          selectPrice = items[i].seckill_price
          selectStock = items[i].seckill_stock
          selectModelId = items[i].id
          selectImgurl = items[i].img_url
        }
      }
    } else {
      selectPrice = goods.seckill_price
      selectStock = goods.seckill_stock
      allStock = goods.seckill_stock
      selectImgurl = goods.cover
    }
    goods.model = goodsModel
    if (Number(goods.max_can_use_integral) != 0) {
      discountStr =
        '（积分可抵扣' + Number(goods.max_can_use_integral) / 100 + '元）'
    }
    let expressSort = goods.goods_express_data.express_fee_sort
    if (expressSort.length == 1) {
      let express = expressSort[0]
      if (express == 0) {
        goods.express_fee = '包邮'
      } else {
        goods.express_fee = express + '元'
      }
    } else {
      goods.express_fee = expressSort[0] + '~' + expressSort[1] + '元'
    }
    if (goods.is_seckill == 1) {
      goods.downCount = {
        hours: '00',
        minutes: '00',
        seconds: '00'
      }
      if (goods.seckill_start_state == 0) {
        _this.downcount = app.beforeSeckillDownCount(goods, _this, 'goodsInfo')
      } else if (goods.seckill_start_state == 1) {
        _this.downcount = app.duringSeckillDownCount(goods, _this, 'goodsInfo')
      }
    }
    let loaclDayTime =
      new Date(new Date().toLocaleDateString()).getTime() / 1000
    let tomorrowTime = loaclDayTime + 86400
    let afterTomorrowTime = tomorrowTime + 86400
    let date = new Date(goods.seckill_start_timestamp * 1000)
    let m = date.getMonth() + 1
    let d = date.getDate()
    let h = date.getHours()
    let min = date.getMinutes()
    goods.seckill_startTime = ''
    if (goods.seckill_start_timestamp <= tomorrowTime) {
      goods.startDay = 1
    } else if (
      goods.seckill_start_timestamp > tomorrowTime &&
      goods.seckill_start_timestamp <= afterTomorrowTime
    ) {
      goods.startDay = 2
      if (min == '00') {
        goods.seckill_startTime = '明日' + h + '点整开抢'
      } else if (min != '00' && min < 10) {
        goods.seckill_startTime = '明日' + h + ':0' + min + '开抢'
      } else {
        goods.seckill_startTime = '明日' + h + ':' + min + '开抢'
      }
    } else if (goods.seckill_start_timestamp > afterTomorrowTime) {
      goods.startDay = 2
      if (min == '00') {
        goods.seckill_startTime = m + '月' + d + '日' + h + '点整开抢'
      } else if (min != '00' && min < 10) {
        goods.seckill_startTime = m + '月' + d + '日' + h + ':0' + min + '开抢'
      } else {
        goods.seckill_startTime = m + '月' + d + '日' + h + ':' + min + '开抢'
      }
    }
    if (this.data.seckillType == 1) {
      // 配送方式过滤活动秒杀
      for (let i = 0; i < goods.pick_up_type.length; i++) {
        goods.pick_up_type[i] == 4 && goods.pick_up_type.splice(i, 1)
      }
    }
    _this.setData({
      goodsInfo: goods,
      modelStrs: modelStrs,
      'selectModelInfo.models': selectModels || '',
      'selectModelInfo.stock': selectStock || '',
      'selectModelInfo.price': selectPrice || '',
      'selectModelInfo.modelId': selectModelId || '',
      'selectModelInfo.models_text': selectText || '',
      'selectModelInfo.imgurl': selectImgurl || '',
      'selectModelInfo.virtualPrice': selectVirtualPrice || '',
      allStock: allStock || '',
      priceDiscountStr: discountStr || ''
    })
    _this.getAssessList(0, 1)
  }
  showBuyDirectly = () => {
    if (this.data.isSeckill && this.data.goodsInfo.seckill_start_state != 1) {
      app.showModal({ content: '当前秒杀商品不在秒杀时间范围内，不能立即购买' })
      return
    }
    this.setData({
      addToShoppingCartHidden: false,
      ifAddToShoppingCart: false,
      imageOrVideo: 'image'
    })
  }
  showAddToShoppingCart = () => {
    if (this.data.isSeckill && this.data.goodsInfo.seckill_start_state == 2) {
      app.showModal({ content: '当前秒杀已结束，不能加入购物车' })
      return
    }
    this.setData({
      addToShoppingCartHidden: false,
      ifAddToShoppingCart: true,
      imageOrVideo: 'image'
    })
  }
  hiddeAddToShoppingCart = () => {
    this.setData({
      addToShoppingCartHidden: true
    })
  }
  selectSubModel = e => {
    var dataset = e.target.dataset,
      modelIndex = dataset.modelIndex,
      submodelIndex = dataset.submodelIndex,
      data = {},
      selectModels = this.data.selectModelInfo.models,
      model = this.data.goodsInfo.model,
      text = ''
    selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex]
    for (let i = 0; i < selectModels.length; i++) {
      let selectSubModelId = model[i].subModelId
      for (let j = 0; j < selectSubModelId.length; j++) {
        if (selectModels[i] == selectSubModelId[j]) {
          text += '“' + model[i].subModelName[j] + '” '
        }
      }
    }
    data['selectModelInfo.models'] = selectModels
    data['selectModelInfo.models_text'] = text
    this.setData(data)
    this.resetSelectCountPrice()
  }
  resetSelectCountPrice = () => {
    var _this = this,
      selectModelIds = this.data.selectModelInfo.models.join(','),
      modelItems = this.data.goodsInfo.model_items,
      data = {}
    for (var i = modelItems.length - 1; i >= 0; i--) {
      if (modelItems[i].model == selectModelIds) {
        if (_this.data.isSeckill) {
          //假如是秒杀
          data['selectModelInfo.stock'] = modelItems[i].seckill_stock
          data['selectModelInfo.price'] = modelItems[i].seckill_price
          data['selectModelInfo.modelId'] = modelItems[i].id
          data['selectModelInfo.imgurl'] = modelItems[i].img_url
          data['seckill_activity_goods_id'] =
            modelItems[i].seckill_activity_goods_id
        } else {
          data['selectModelInfo.stock'] = modelItems[i].stock
          data['selectModelInfo.price'] = modelItems[i].price
          data['selectModelInfo.modelId'] = modelItems[i].id
          data['selectModelInfo.imgurl'] = modelItems[i].img_url
          data['selectModelInfo.virtualPrice'] = modelItems[i].virtual_price
        }
        break
      }
    }
    this.setData(data)
  }
  clickMinusButton = e => {
    var count = this.data.selectModelInfo.buyCount
    if (count <= 1) {
      return
    }
    this.setData({
      'selectModelInfo.buyCount': count - 1
    })
  }
  clickPlusButton = e => {
    var selectModelInfo = this.data.selectModelInfo,
      goodsInfo = this.data.goodsInfo,
      count = selectModelInfo.buyCount,
      stock = selectModelInfo.stock
    if (count >= stock) {
      app.showModal({ content: '购买数量不能大于库存' })
      return
    }
    if (this.data.isSeckill && count >= goodsInfo.seckill_buy_limit) {
      app.showModal({ content: '购买数量不能大于秒杀限购数量' })
      return
    }
    this.setData({
      'selectModelInfo.buyCount': count + 1
    })
  }
  sureAddToShoppingCart = () => {
    var that = this,
      param = {}
    if (this.data.seckillType == 0) {
      param = {
        goods_id: this.data.goodsId,
        model_id: this.data.selectModelInfo.modelId || '',
        num: this.data.selectModelInfo.buyCount,
        sub_shop_app_id: this.data.franchiseeId || '',
        is_seckill: 1
      }
    } else {
      param = {
        goods_id: this.data.goodsId,
        model_id: this.data.selectModelInfo.modelId || '',
        num: this.data.selectModelInfo.buyCount,
        sub_shop_app_id: this.data.franchiseeId || '',
        is_seckill: 1,
        form_data: {
          seckill_activity_id: this.data.seckill_activity_id,
          seckill_activity_time_id: this.data.seckill_activity_time_id,
          seckill_activity_goods_id: this.data.seckill_activity_goods_id
        }
      }
    }
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/addCart',
      data: param,
      method: 'post',
      success: function (res) {
        app.showToast({
          title: '添加成功',
          icon: 'success'
        })
        setTimeout(function () {
          that.hiddeAddToShoppingCart()
        }, 1000)
      }
    })
  }
  buyDirectlyNextStep = e => {
    var franchiseeId = this.data.franchiseeId,
      that = this,
      param = {}
    if (this.data.seckillType == 0) {
      param = {
        goods_id: this.data.goodsId,
        model_id: this.data.selectModelInfo.modelId || '',
        num: this.data.selectModelInfo.buyCount,
        sub_shop_app_id: franchiseeId || '',
        is_seckill: 1
      }
    } else {
      param = {
        goods_id: this.data.goodsId,
        model_id: this.data.selectModelInfo.modelId || '',
        num: this.data.selectModelInfo.buyCount,
        sub_shop_app_id: franchiseeId || '',
        is_seckill: 1,
        form_data: {
          seckill_activity_id: this.data.seckill_activity_id,
          seckill_activity_time_id: this.data.seckill_activity_time_id,
          seckill_activity_goods_id: this.data.seckill_activity_goods_id
        }
      }
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/addCart',
      data: param,
      method: 'post',
      success: function (res) {
        var cart_arr = [res.data],
          pagePath =
            '/seckill/pages/previewSeckillOrder/previewSeckillOrder?cart_arr=' +
            encodeURIComponent(cart_arr) +
            '&secType=' +
            that.data.seckillType
        franchiseeId && (pagePath += '&franchisee=' + franchiseeId)
        that.hiddeAddToShoppingCart()
        app.turnToPage(pagePath)
      }
    })
  }
  makeAppointment = () => {
    var franchiseeId = this.data.franchiseeId,
      unitTime =
        this.data.modelStrs[0] &&
        this.data.modelStrs[0].substring(this.data.modelStrs[0].length - 1),
      unitType = unitTime == '分' ? 1 : unitTime == '时' ? 2 : 3,
      pagePath =
        '/eCommerce/pages/makeAppointment/makeAppointment?detail=' +
        this.data.goodsId +
        (franchiseeId ? '&franchisee=' + franchiseeId : '') +
        ('&param=' + unitType)
    app.turnToPage(pagePath)
  }
  inputBuyCount = e => {
    var count = +e.target.value,
      selectModelInfo = this.data.selectModelInfo,
      goodsInfo = this.data.goodsInfo,
      stock = +selectModelInfo.stock
    if (count >= stock) {
      count = stock
      app.showModal({ content: '购买数量不能大于库存' })
    }
    if (this.data.isSeckill && count >= +goodsInfo.seckill_buy_limit) {
      count = goodsInfo.seckill_buy_limit
      app.showModal({ content: '购买数量不能大于秒杀限购数量' })
    }
    this.setData({
      'selectModelInfo.buyCount': +count
    })
  }
  showQRCodeComponent = () => {
    let that = this
    let goodsInfo = this.data.goodsInfo
    // let animation = app.createAnimation({
    //   timingFunction: 'ease',
    //   duration: 400
    // })
    app.sendRequest({
      url: '/index.php?r=AppDistribution/DistributionShareQRCode',
      data: {
        obj_id: that.data.goodsId,
        text: goodsInfo.share_title || goodsInfo.title,
        price:
          goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0
            ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice
            : goodsInfo.price,
        goods_img: goodsInfo.img_urls ? goodsInfo.img_urls[0] : goodsInfo.cover,
        sub_shop_id: that.data.franchiseeId,
        type: that.data.seckillType == 0 ? 5 : 21,
        seckill_activity_arr: {
          seckill_activity_id:
            that.data.seckillType == 1 ? this.data.seckill_activity_id : '',
          seckill_activity_time_id:
            that.data.seckillType == 1 ? this.data.seckill_activity_time_id : ''
        }
      },
      method: 'post',
      success: function (res) {
        // animation.bottom('0').step()
        // that.setData({
        //   'pageQRCodeData.shareDialogShow': 0,
        //   'pageQRCodeData.shareMenuShow': true,
        //   'pageQRCodeData.goodsInfo': res.data,
        //   'pageQRCodeData.goodsInfo.isSeckill': 1,
        //   'pageQRCodeData.goodsInfo.seckill_price': goodsInfo.seckill_price,
        //   'pageQRCodeData.animation': animation.export()
        // })
        appInstance.pageQrcodeRef.current.show({
          pageQRCodeData: {
            'shareDialogShow': 0,
            'shareMenuShow': true,
            'goodsInfo': {
              ...res.data,
              isSeckill: 1,
              seckill_price: goodsInfo.seckill_price
            }
          }
        });
      }
    })
  }
  showShareMenu = () => {
    app.showShareMenu()
  }
  makePhoneCall = () => {
    app.makePhoneCall(this.data.appointmentPhone)
  }
  hideShareMenu = () => {
    this.setData({
      hideShareMenu: true
    })
  }
  showPageCode = () => { }
  oneSelectDetailCommet = e => {
    this.setData({
      detailCommetType: e.target.dataset.type
    })
  }
  getAssessList = (commnetType, page, append) => {
    var that = this
    app.getAssessList({
      method: 'post',
      data: {
        goods_id: that.data.goodsId,
        idx_arr: {
          idx: 'level',
          idx_value: commnetType
        },
        page: page,
        page_size: 20,
        sub_shop_app_id: this.data.franchiseeId
      },
      success: function (res) {
        var commentData = res.data
        if (append) {
          commentData = that.data.commentArr.concat(commentData)
        }
        that.setData({
          commentArr: commentData,
          commentNums: res.num,
          commentPage: that.data.commentPage + 1,
          commentExample: res.data[0] || '',
          commentTotalPage: res.total_page,
          displayComment:
            that.data.goodsInfo.goods_type === '0'
              ? +res.num[0] > 0
                ? false
                : true
              : that.data.goodsInfo.appointment_info &&
                that.data.goodsInfo.appointment_info.display_comment == '1'
                ? that.data.goodsInfo.appointment_info.display_comment
                : ''
        })
      }
    })
  }
  clickCommentLabel = e => {
    var commentType = e.target.dataset.type,
      data = {}
    data.commentPage = 1
    data.commnetType = commentType
    this.setData(data)
    this.getAssessList(commentType, 1)
  }
  clickPlusImages = e => {
    app.previewImage({
      current: e.currentTarget.dataset.src,
      urls: e.currentTarget.dataset.srcarr && JSON.parse(e.currentTarget.dataset.srcarr)
    })
  }
  carouselIndex = index => {
    this.setData({
      carouselCurrentIndex: index + 1
    })
  }
  toCouponList = () => {
    app.turnToPage(
      '/eCommerce/pages/couponReceiveListPage/couponReceiveListPage'
    )
  }
  changeImageOrVideo = event => {
    this.setData({
      videoPoster: false,
      imageOrVideo: event.currentTarget.dataset.type
    })
  }
  toRecommendGoodsDetail = event => {
    app.turnToGoodsDetail(event)
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    })
  }
  startPlayVideo = () => {
    let video = app.createVideoContext('carousel-video')
    this.setData({
      videoPoster: true
    })
    video.play()
  }
  formSubmitRemind = e => {
    let _this = this
    let formid = ''
    let goodsInfo = JSON.parse(e.currentTarget.dataset.goods)
    if (e.target.formId != 'the formId is a mock one') {
      formid = e.target.formId
    }
    let loaclDayTime =
      new Date(new Date().toLocaleDateString()).getTime() / 1000
    let seventDay = 86400 * 7
    if (goodsInfo.seckill_start_timestamp > loaclDayTime + seventDay) {
      app.showModal({ content: '请于开抢前7天来设置哦' })
      return
    }
    let data = e.currentTarget.dataset
    let newData = {}
    app.sendRequest({
      url: '/index.php?r=AppShop/setActivityGoodsCare',
      method: 'post',
      data: {
        data_id: goodsInfo.id,
        activity_type: 1,
        activity_id: goodsInfo.seckill_activity_id,
        seckill_activity_arr: {
          seckill_activity_time_id: goodsInfo.seckill_activity_time_id,
          form_id: formid
        },
        is_deleted: data.is_deleted
      },
      success: function (res) {
        if (!res.status) {
          if (data.is_deleted == 0) {
            app.showModal({
              title: '提示',
              content: '开抢前3分钟提醒你哦',
              showCancel: false
            })
            newData['goodsInfo.is_seckill_activity_care'] = 1
            newData['goodsInfo.seckill_activity_care'] =
              goodsInfo.seckill_activity_care + 1
          } else {
            app.showModal({
              title: '提示',
              content: '提醒已取消，到时你会抢不到哦!',
              showCancel: false
            })
            newData['goodsInfo.is_seckill_activity_care'] = 0
            newData['goodsInfo.seckill_activity_care'] =
              goodsInfo.seckill_activity_care - 1
          }
          _this.setData(newData)
        }
      }
    })
  }
  addFavoriteGoods = event => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/addFavoriteGoods',
      data: {
        form_id: event.target.formId,
        goods_id: _this.data.goodsId,
        sub_shop_app_id: _this.data.franchiseeId
      },
      success: function (res) {
        _this.setData({
          'goodsInfo.is_favorite': 1
        })
      },
      complete: function () {
        app.showToast({
          title: '收藏成功!',
          image: '/images/favorites.png'
        })
      }
    })
  }
  deleteFavoriteGoods = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/deleteFavoriteGoods',
      method: 'post',
      data: {
        goods_id_arr: [_this.data.goodsId],
        sub_shop_app_id: _this.data.franchiseeId
      },
      success: function (res) {
        _this.setData({
          'goodsInfo.is_favorite': 0
        })
      },
      complete: function () {
        app.showToast({
          title: '取消收藏!',
          image: '/images/cancel-favorites.png'
        })
      }
    })
  }

  render() {
    const {
      pageQRCodeData,
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      showGetUserInfo,
      topNavBarData,
      page_hidden,
      goodsInfo,
      cartGoodsNum,
      imageOrVideo,
      videoPoster,
      storeStyle,
      modelStrs,
      hidestock,
      allStock,
      appointmentDesc,
      displayComment,
      commentNums,
      commentExample,
      defaultPhoto,
      wxParseDescription,
      isSeckill,
      franchiseeId,
      sessionFrom,
      carouselCurrentIndex,
      detailCommetType,
      commnetType,
      commentArr,
      addToShoppingCartHidden,
      selectModelInfo,
      isShowVirtualPrice,
      ifAddToShoppingCart
    } = this.state

    return (
      <div className="official-page seckill-detail">
        <TopNav title="商品详情"/>
        <div className="goods-detail-wrap" hidden={page_hidden}>
          <div
            className="goods-detail-nav"
            style={convertLineStyleData('top:' + topNavBarData.totalHeight + 'px;')}
          >
            <div>
              {(!goodsInfo.detail_type || goodsInfo.detail_type == 0) && (
                <div
                  className="pull-right ico-moon icon-notebook"
                  onClick={this.goToMyOrder}
                ></div>
              )}
              {(!goodsInfo.detail_type || goodsInfo.detail_type == 0) && (
                <div
                  className="pull-right ico-moon icon-store2"
                  onClick={this.goToHomepage}
                >
                  {!!+cartGoodsNum && cartGoodsNum != 0 && (
                    <div className="goods-detail-cart-num">
                      {cartGoodsNum}
                    </div>
                  )}
                </div>
              )}
              {goodsInfo.detail_type != 2 && (
                <div
                  className="pull-right ico-moon icon-new-share"
                  onClick={this.showQRCodeComponent}
                ></div>
              )}
            </div>
          </div>
          {(!goodsInfo.detail_type || goodsInfo.detail_type == 0) && (
            <div className="goods-detail-content oldStyle">
              <div className="goods-detail-section">
                {imageOrVideo == 'image' && (
                  <div className="image-carousel-container">
                    {!goodsInfo.img_urls ? (
                      <div className="goods-cover-container">
                        <img
                          data-src={goodsInfo.cover}
                          onClick={this.clickPlusImages}
                          src={goodsInfo.cover}
                          mode="aspectFill"
                        />
                      </div>
                    ) : (
                        <div className="slick-carousel-container">
                          <Carousel
                            dots={false}
                            infinite={true}
                            autoplay={true}
                            autoplayInterval={5000}
                            afterChange={this.carouselIndex}>
                            {goodsInfo.img_urls.map((item, index) => {
                              return (
                                <div key={index}>
                                  <img
                                    data-src={item}
                                    data-srcarr={JSON.stringify(goodsInfo.img_urls)}
                                    onClick={this.clickPlusImages}
                                    className="slide-image"
                                    src={item}
                                    onLoad={() => {
                                      window.dispatchEvent(new Event('resize'));
                                    }} />
                                </div>
                              )
                            })}
                          </Carousel>
                        </div>
                      )}
                    {goodsInfo.video_url && (
                      <div className="image-video-menu">
                        <span
                          className={imageOrVideo == 'image' ? 'active' : ''}
                          data-type="image"
                          onClick={this.changeImageOrVideo}
                        >
                          图片
                        </span>
                        <span
                          className={imageOrVideo == 'video' ? 'active' : ''}
                          data-type="video"
                          onClick={this.changeImageOrVideo}
                        >
                          视频
                        </span>
                      </div>
                    )}
                  </div>
                )}
                {goodsInfo.video_url && imageOrVideo == 'video' && (
                  <div className="video-carousel-container">
                    <video
                      src={goodsInfo.video_url}
                      id="carousel-video"
                      hidden={!videoPoster}
                    >
                      {goodsInfo.video_url && (
                        <CoverView className="image-video-menu">
                          <CoverView
                            className={imageOrVideo == 'image' ? 'active' : ''}
                            data-type="image"
                            onClick={this.changeImageOrVideo}
                          >
                            图片
                          </CoverView>
                          <CoverView
                            className={imageOrVideo == 'video' ? 'active' : ''}
                            data-type="video"
                            onClick={this.changeImageOrVideo}
                          >
                            视频
                          </CoverView>
                        </CoverView>
                      )}
                    </video>
                    <div className="videoele-cover-view" hidden={videoPoster}>
                      <div className="videoele-poster-wrap">
                        <img
                          className="videoele-poster"
                          src={goodsInfo.video_img}
                          mode="scaleToFill"
                        />
                      </div>
                      <div
                        className="videoele-play-icon"
                        onClick={this.startPlayVideo}
                      >
                        <img
                          className="videoele-play-image"
                          src="http://cdn.jisuapp.cn/static/webapp/images/play.png"
                          mode="scaleToFill"
                        />
                      </div>
                      <div className="image-video-menu">
                        <span
                          className={imageOrVideo == 'image' ? 'active' : ''}
                          data-type="image"
                          onClick={this.changeImageOrVideo}
                        >
                          图片
                        </span>
                        <span
                          className={imageOrVideo == 'video' ? 'active' : ''}
                          data-type="video"
                          onClick={this.changeImageOrVideo}
                        >
                          视频
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className="goods-seckill"
                  style={convertLineStyleData(
                    'background:linear-gradient(to right,' +
                    (storeStyle.theme ? storeStyle.theme : '#FF7100') +
                    ',' +
                    (storeStyle.secondary ? storeStyle.secondary : '#FFAC0C') +
                    ');'
                  )}
                >
                  <div className="goods-seckill-left">
                    <div className="goods-seckill-current">
                      <div className="goods-current-price">
                        <span className="seckill-price-unit">¥</span>
                        <span className="goods-seckill-price">
                          {goodsInfo.seckill_price}
                        </span>
                      </div>
                      <div className="goods-seckill-original">
                        <div className="goods-original-price">
                          {'¥' + goodsInfo.price}
                          <span className="goods-original-price-line"></span>
                        </div>
                        <div className="seckill-attention">
                          {goodsInfo.seckill_activity_care + '人关注'}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      'goods-seckill-right ' +
                      (goodsInfo.seckill_start_state == 2 ? 'seckill-end' : '')
                    }
                  >
                    <div className="countdown">
                      {goodsInfo.seckill_start_state == 0 &&
                        goodsInfo.startDay == 1 ? (
                          <label>距开始还剩</label>
                        ) : goodsInfo.seckill_start_state == 0 &&
                          goodsInfo.startDay == 2 ? (
                            <label>
                              <span className="ico-moon icon-seckill-detail-alarm"></span>
                              开抢时间
                        </label>
                          ) : goodsInfo.seckill_start_state == 1 ? (
                            <label>距结束还剩</label>
                          ) : (
                              goodsInfo.seckill_start_state == 2 && (
                                <label>已结束</label>
                              )
                            )}
                      {(goodsInfo.seckill_start_state == 1 ||
                        (goodsInfo.seckill_start_state == 0 &&
                          goodsInfo.startDay == 1)) && (
                          <React.Fragment>
                            {!!goodsInfo.downCount.days && (
                              <span className="days">
                                {goodsInfo.downCount.days + '天'}
                              </span>
                            )}
                            <span
                              className="hours countdown-text"
                              style={convertLineStyleData('color:' + storeStyle.theme)}
                            >
                              {goodsInfo.downCount.hours}
                            </span>
                            :
                          <span
                              className="minutes countdown-text"
                              style={convertLineStyleData('color:' + storeStyle.theme)}
                            >
                              {goodsInfo.downCount.minutes}
                            </span>
                            :
                          <span
                              className="seconds countdown-text"
                              style={convertLineStyleData('color:' + storeStyle.theme)}
                            >
                              {goodsInfo.downCount.seconds}
                            </span>
                          </React.Fragment>
                        )}
                      {goodsInfo.seckill_start_state == 0 &&
                        goodsInfo.startDay == 2 && (
                          <div
                            className="seckill-start-time"
                            style={convertLineStyleData('color:' + storeStyle.theme)}
                          >
                            {goodsInfo.seckill_startTime}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                <div className="goods-header">
                  <div className="goods-title">
                    <span
                      className="ico-moon icon-seckill-alarm cover-icon-seckill-alarm"
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                    ></span>
                    {goodsInfo.title}
                  </div>
                  {goodsInfo.model_items && !!goodsInfo.model_items.length && (
                    <div className="goods-models">
                      {goodsInfo.model.map((item, index) => {
                        return (
                          <div
                            className="goods-model-item"
                            key={item.id}
                            hidden={!item.subModelName}
                          >
                            <span className="goods-model-cate">
                              {item.name}
                            </span>
                            <span className="goods-model-detail">
                              {modelStrs[item.id]}
                            </span>
                          </div>
                        )
                      })}
                    </div>
                  )}
                  {goodsInfo.goods_type == 0 && (
                    <div className="goods-other-info">
                      <div>{'运费:' + (goodsInfo.express_fee || '包邮')}</div>
                      {!hidestock && (
                        <div>{'库存:' + (allStock || goodsInfo.stock)}</div>
                      )}
                    </div>
                  )}
                  {goodsInfo.goods_type == 0 && (
                    <div className="goods-other-info">
                      <label>取货方式</label>
                      <div className="address-pick-up">
                        {goodsInfo.pick_up_type.map((item, index) => {
                          return (
                            <div key={item}>
                              <span
                                style={convertLineStyleData('color:' + storeStyle.theme)}
                                className="ico-moon icon-goods-support-delivery suporrt"
                              ></span>
                              <span>
                                {item == 1
                                  ? '快递'
                                  : item == 2
                                    ? '同城'
                                    : item == 3
                                      ? '自提'
                                      : '点餐'}
                              </span>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {goodsInfo.goods_type == 1 && (
                <div className="goods-appointment">
                  <div
                    className="appointment-instructions"
                    style={convertLineStyleData('color:#666;')}
                  >
                    预约说明
                  </div>
                  <span
                    className="appointment-remarks"
                    style={convertLineStyleData('color:#999;word-break:break-all;')}
                  >
                    {appointmentDesc}
                  </span>
                </div>
              )}
              <div
                style={convertLineStyleData('padding: 20rpx;text-align:center;background:#f4f4f4;color:#b2b2b2;font-size:24rpx;')}
                hidden={displayComment}
              >
                <div className="line"></div>
                <div className="ico-moon icon-good-comment goods-ico"></div>
                <div style={convertLineStyleData('display: inline-block;vertical-align:middle;margin-right:4px;')}>
                  评价
                </div>
                <div className="line"></div>
              </div>
              <div className="goods-detail-section" hidden={displayComment}>
                <div className="comment-title">
                  <div style={convertLineStyleData('border-bottom: 1px solid #f4f4f4;padding-bottom:20rpx;')}>
                    {'评价 (' + (commentNums[0] || 0) + ')'}
                  </div>
                </div>
                <div className="block-item">
                  {commentExample && (
                    <div>
                      <div className="comment-item">
                        <div>
                          <img
                            className="comment-user-photo"
                            src={
                              commentExample.buyer_headimgurl || defaultPhoto
                            }
                          />
                          <span className="commentPersonName">
                            {commentExample.buyer_nickname}
                          </span>
                        </div>
                        <div className="comment-date">
                          {commentExample.add_time}
                        </div>
                        <div className="comment-content">
                          {commentExample.assess_info.content}
                        </div>
                        {commentExample.assess_info.has_img && (
                          <div className="comPage-comment-pics">
                            {commentExample.assess_info.img_arr.map(
                              (imgSrc, index) => {
                                return (
                                  <img
                                    src={imgSrc}
                                    key={index}
                                    data-src={imgSrc}
                                    data-srcarr={
                                      JSON.stringify(commentExample.assess_info.img_arr)
                                    }
                                    onClick={this.clickPlusImages}
                                  />
                                )
                              }
                            )}
                          </div>
                        )}
                      </div>
                      <div style={convertLineStyleData('text-align:center;')}>
                        <button
                          className="btn lookAllComments"
                          onClick={this.goToCommentPage}
                        >
                          查看全部评价
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div style={convertLineStyleData('padding: 20rpx;text-align:center;background:#f4f4f4;color:#b2b2b2;font-size:24rpx;')}>
                <div className="line"></div>
                <div className="ico-moon icon-good-detail goods-ico"></div>
                <div style={convertLineStyleData('display: inline-block;vertical-align:middle;margin-right:4px;')}>
                  详情
                </div>
                <div className="line"></div>
              </div>
              <div className="goods-detail-section">
                <div className="comment-title">
                  <div style={convertLineStyleData('border-bottom: 1px solid #f4f4f4;padding-bottom:20rpx;')}>
                    产品详情
                  </div>
                </div>
                <div className="goods-details rich-text" dangerouslySetInnerHTML={{ __html: goodsInfo.description && goodsInfo.description.replace(/href=".*?"/g,'') }}>
                </div>
              </div>
              {goodsInfo.recommend_info && !!goodsInfo.recommend_info.length && (
                <div className="goods-recommend">
                  <div className="two-recommend">店铺推荐</div>
                  <ScrollView className="recommend-content" scroll-x="true">
                    {goodsInfo.recommend_info.map((item, index) => {
                      return (
                        <div
                          className="recommend-goods"
                          key={item.form_data.id}
                          onClick={this.toRecommendGoodsDetail}
                          data-id={item.form_data.id}
                          data-goods-type={item.form_data.goods_type}
                        >
                          <img src={item.form_data.cover} />
                          <div className="recommend-goods-title">
                            {item.form_data.title}
                          </div>
                          <span className="recommend-goods-price">
                            {'¥' + item.form_data.price}
                          </span>
                        </div>
                      )
                    })}
                  </ScrollView>
                </div>
              )}
            </div>
          )}
          {goodsInfo.detail_type != 2 && (
            <div className="goods-bottom-opt">
              <React.Fragment>
                <div className="flex-sub-box-3">
                  <div
                    className={
                      'goods-opt-item flex-sub-box-' +
                      (isSeckill || franchiseeId ? '2' : '3')
                    }
                    onClick={this.goToShoppingCart}
                  >
                    <div className="bottom-border-right">
                      <span className="ico-moon icon-new-goods-shopping"></span>
                      <div className="margig-top-2">购物车</div>
                    </div>
                  </div>
                  {!isSeckill && !franchiseeId && (
                    <div className="form-contain goods-opt-item flex-sub-box-3">
                      <form>
                        <button type="button" onClick={goodsInfo.is_favorite == 1 ? this.deleteFavoriteGoods : this.addFavoriteGoods}>
                          <div className="bottom-border-right">
                            <span
                              style={convertLineStyleData(
                                goodsInfo.is_favorite == 1
                                  ? 'color:' + storeStyle.theme
                                  : ''
                              )}
                              className={
                                'ico-moon icon-' +
                                (goodsInfo.is_favorite == 1
                                  ? 'collect-solid'
                                  : 'goods-detail-favorites')
                              }
                            ></span>
                            <div>收藏</div>
                          </div>
                        </button>
                      </form>
                    </div>
                  )}
                  <div
                    className={
                      'goods-opt-item flex-sub-box-' +
                      (isSeckill || franchiseeId ? '2' : '3')
                    }
                  >
                    <div className="ico-moon icon-service2">
                      {/* TODO
                      <ContactButton
                        type="default-dark"
                        size="20"
                        sessionFrom={sessionFrom}
                      ></ContactButton> */}
                    </div>
                    <div>客服</div>
                  </div>
                </div>
                {goodsInfo.seckill_progress != 100 &&
                  goodsInfo.seckill_start_state != 2 && (
                    <div className="flex-sub-box-3">
                      <label
                        style={convertLineStyleData(
                          'background:' +
                          storeStyle.secondary +
                          ';color:' +
                          (storeStyle.secondary == '#ACD3FA' ||
                            storeStyle.secondary == '#FFCFDF' ||
                            storeStyle.secondary == '#ffffff' ||
                            storeStyle.secondary == '#DFF3ED' ||
                            storeStyle.secondary == '#FAF7ED'
                            ? storeStyle.theme
                            : '')
                        )}
                        className={
                          'btn addToShoppingCart ' +
                          (goodsInfo.seckill_start_state == 2 ? 'disabled' : '')
                        }
                        onClick={this.showAddToShoppingCart}
                      >
                        加入购物车
                      </label>
                    </div>
                  )}
                {goodsInfo.seckill_progress != 100 &&
                  goodsInfo.seckill_start_state == 1 && (
                    <div className="flex-sub-box-3">
                      <label
                        className={
                          'btn btn-orange buy-goods-directly ' +
                          (goodsInfo.seckill_start_state != 1 ? 'disabled' : '')
                        }
                        style={convertLineStyleData('background:' + storeStyle.theme + ';')}
                        onClick={this.showBuyDirectly}
                      >
                        立即购买
                      </label>
                    </div>
                  )}
                {goodsInfo.seckill_start_state == 0 &&
                  goodsInfo.is_seckill_activity_care == 0 && (
                    <div className="flex-sub-box-3">
                      <form>
                        <button
                          type="button"
                          className="form-button"
                          data-goods={JSON.stringify(goodsInfo)}
                          data-is_deleted="0"
                          onClick={this.formSubmitRemind}>
                          <label
                            className={
                              'btn btn-orange buy-goods-directly ' +
                              (goodsInfo.seckill_start_state != 1
                                ? 'disabled'
                                : '')
                            }
                            style={convertLineStyleData('background:' + storeStyle.theme + ';')}
                          >
                            设置提醒
                          </label>
                        </button>
                      </form>
                    </div>
                  )}
                {goodsInfo.seckill_start_state == 0 &&
                  goodsInfo.is_seckill_activity_care == 1 && (
                    <div className="flex-sub-box-3">
                      <form>
                        <button
                          type="button"
                          className="form-button"
                          data-goods={JSON.stringify(goodsInfo)}
                          daga-is_deleted="1"
                          onClick={this.formSubmitRemind}
                          >
                          <label
                            className={
                              'btn btn-orange buy-goods-directly ' +
                              (goodsInfo.seckill_start_state != 1
                                ? 'disabled'
                                : '')
                            }
                            style={convertLineStyleData('background:' + storeStyle.theme + ';')}
                          >
                            取消提醒
                          </label>
                        </button>
                      </form>
                    </div>
                  )}
                {goodsInfo.seckill_progress == 100 &&
                  goodsInfo.seckill_start_state == 1 && (
                    <div className="flex-sub-box-6">
                      <label
                        className={
                          'btn btn-orange buy-goods-directly ' +
                          (goodsInfo.seckill_start_state != 1
                            ? 'disabled'
                            : '') +
                          '  background-cccccc'
                        }
                      >
                        商品已抢光
                      </label>
                    </div>
                  )}
                {goodsInfo.seckill_start_state == 2 && (
                  <div className="flex-sub-box-6">
                    <label
                      className={
                        'btn btn-orange buy-goods-directly ' +
                        (goodsInfo.seckill_start_state != 1 ? 'disabled' : '') +
                        '  background-cccccc'
                      }
                    >
                      活动已结束
                    </label>
                  </div>
                )}
              </React.Fragment>
            </div>
          )}
        </div>
        {/*  模式1模式2公用轮播  */}
        {goodsInfo.detail_type != 0 && (
          <div className="goods-detail-section">
            {goodsInfo.buyer_list && !!goodsInfo.buyer_list.length && (
              <div className="goods-buy-record">
                <Carousel
                  dots={false}
                  infinite={true}
                  autoplay={true}
                  autoplayInterval={3000}>
                  {goodsInfo.buyer_list.map((item, index) => {
                    return (
                      <div key={index}>
                        <img
                          src={item.cover_thumb}
                          onLoad={() => {
                            window.dispatchEvent(new Event('resize'));
                          }} />
                        <span>{item.nickname + '购买成功'}</span>
                      </div>
                    )
                  })}
                </Carousel>
              </div>
            )}
            {imageOrVideo == 'image' && (
              <div className="image-carousel-container">
                {!goodsInfo.img_urls ? (
                  <div className="goods-cover-container">
                    <img
                      data-src={goodsInfo.cover}
                      onClick={this.clickPlusImages}
                      src={goodsInfo.cover}
                      mode="aspectFill"
                    />
                  </div>
                ) : (
                    <div className="slick-carousel-container">
                      <Carousel
                        dots={false}
                        infinite={true}
                        autoplay={true}
                        autoplayInterval={5000}
                        afterChange={this.carouselIndex}>
                        {goodsInfo.img_urls.map((item, index) => {
                          return (
                            <div key={index}>
                              <img
                                data-src={item}
                                data-srcarr={JSON.stringify(goodsInfo.img_urls)}
                                onClick={this.clickPlusImages}
                                className="slide-image"
                                src={item}
                                onLoad={() => {
                                  window.dispatchEvent(new Event('resize'));
                                }} />
                            </div>
                          )
                        })}
                      </Carousel>
                      <div className="carousel-index">
                        {carouselCurrentIndex + '/' + goodsInfo.img_urls.length}
                      </div>
                    </div>
                  )}
                {goodsInfo.video_url && (
                  <div className="image-video-menu">
                    <span
                      className={imageOrVideo == 'image' ? 'active' : ''}
                      data-type="image"
                      onClick={this.changeImageOrVideo}
                    >
                      图片
                    </span>
                    <span
                      className={imageOrVideo == 'video' ? 'active' : ''}
                      data-type="video"
                      onClick={this.changeImageOrVideo}
                    >
                      视频
                    </span>
                  </div>
                )}
              </div>
            )}
            {goodsInfo.video_url && imageOrVideo == 'video' && (
              <div className="video-carousel-container">
                <video
                  src={goodsInfo.video_url}
                  id="carousel-video"
                  hidden={!videoPoster}
                >
                  {goodsInfo.video_url && (
                    <CoverView className="image-video-menu">
                      <CoverView
                        className={imageOrVideo == 'image' ? 'active' : ''}
                        data-type="image"
                        onClick={this.changeImageOrVideo}
                      >
                        图片
                      </CoverView>
                      <CoverView
                        className={imageOrVideo == 'video' ? 'active' : ''}
                        data-type="video"
                        onClick={this.changeImageOrVideo}
                      >
                        视频
                      </CoverView>
                    </CoverView>
                  )}
                </video>
                <div className="videoele-cover-view" hidden={videoPoster}>
                  <div className="videoele-poster-wrap">
                    <img
                      className="videoele-poster"
                      src={goodsInfo.video_img}
                      mode="scaleToFill"
                    />
                  </div>
                  <div
                    className="videoele-play-icon"
                    onClick={this.startPlayVideo}
                  >
                    <img
                      className="videoele-play-image"
                      src="http://cdn.jisuapp.cn/static/webapp/images/play.png"
                      mode="scaleToFill"
                    />
                  </div>
                  <div className="image-video-menu">
                    <span
                      className={imageOrVideo == 'image' ? 'active' : ''}
                      data-type="image"
                      onClick={this.changeImageOrVideo}
                    >
                      图片
                    </span>
                    <span
                      className={imageOrVideo == 'video' ? 'active' : ''}
                      data-type="video"
                      onClick={this.changeImageOrVideo}
                    >
                      视频
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div
              className="goods-seckill"
              style={convertLineStyleData(
                'background:linear-gradient(to right,' +
                (storeStyle.theme ? storeStyle.theme : '#FF7100') +
                ',' +
                (storeStyle.secondary ? storeStyle.secondary : '#FFAC0C') +
                ');'
              )}
            >
              <div className="goods-seckill-left">
                <div className="goods-seckill-current">
                  <div className="goods-current-price">
                    <span className="seckill-price-unit">¥</span>
                    <span className="goods-seckill-price">
                      {goodsInfo.seckill_price}
                    </span>
                  </div>
                  <div className="goods-seckill-original">
                    <div className="goods-original-price">
                      {'¥' + goodsInfo.price}
                      <span className="goods-original-price-line"></span>
                    </div>
                    <div className="seckill-attention">
                      {goodsInfo.seckill_activity_care + '人关注'}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  'goods-seckill-right ' +
                  (goodsInfo.seckill_start_state == 2 ? 'seckill-end' : '')
                }
              >
                <div className="countdown">
                  {goodsInfo.seckill_start_state == 0 &&
                    goodsInfo.startDay == 1 ? (
                      <label>距开始还剩</label>
                    ) : goodsInfo.seckill_start_state == 0 &&
                      goodsInfo.startDay == 2 ? (
                        <label>
                          <span className="ico-moon icon-seckill-detail-alarm"></span>
                          开抢时间
                    </label>
                      ) : goodsInfo.seckill_start_state == 1 ? (
                        <label>距结束还剩</label>
                      ) : (
                          goodsInfo.seckill_start_state == 2 && <label>已结束</label>
                        )}
                  {(goodsInfo.seckill_start_state == 1 ||
                    (goodsInfo.seckill_start_state == 0 &&
                      goodsInfo.startDay == 1)) && (
                      <React.Fragment>
                        {!!goodsInfo.downCount.days && (
                          <span className="days">
                            {goodsInfo.downCount.days + '天'}
                          </span>
                        )}
                        <span
                          className="hours countdown-text"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                        >
                          {goodsInfo.downCount.hours}
                        </span>
                        :
                      <span
                          className="minutes countdown-text"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                        >
                          {goodsInfo.downCount.minutes}
                        </span>
                        :
                      <span
                          className="seconds countdown-text"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                        >
                          {goodsInfo.downCount.seconds}
                        </span>
                      </React.Fragment>
                    )}
                  {goodsInfo.seckill_start_state == 0 &&
                    goodsInfo.startDay == 2 && (
                      <div
                        className="seckill-start-time"
                        style={convertLineStyleData('color:' + storeStyle.theme)}
                      >
                        {goodsInfo.seckill_startTime}
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        )}
        {/*  模式1  */}
        {goodsInfo.detail_type == 1 && (
          <div className="goods-detail-content styleOne">
            <div className="goods-header">
              <div className="goods-title">
                <span
                  className="ico-moon icon-seckill-alarm cover-icon-seckill-alarm"
                  style={convertLineStyleData('color:' + storeStyle.theme)}
                ></span>
                {goodsInfo.title}
              </div>
              <div className="goods-price"></div>
              <div className="goods-coupon" onClick={this.toCouponList}>
                <span>活动：</span>
                <span
                  className="word-orange"
                  style={convertLineStyleData('color:' + storeStyle.theme)}
                >
                  [最新优惠券]
                </span>
                <span className="pull-right color-999">
                  立即领取<span className="ico-moon icon-rightarrow"></span>
                </span>
              </div>
              <div className="goods-freight">
                <div>{'运费：' + (goodsInfo.express_fee || '包邮')}</div>
              </div>
              <div className="goods-freight" onClick={this.showBuyDirectly}>
                <span>选择商品规格</span>
                <span className="pull-right ico-moon icon-rightarrow color-999"></span>
              </div>
              <div className="goods-freight">
                <label>取货方式</label>
                <div className="address-pick-up">
                  {goodsInfo.pick_up_type.map((item, index) => {
                    return (
                      <div key={item}>
                        <span
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                          className="ico-moon icon-goods-support-delivery suporrt"
                        ></span>
                        <span>
                          {item == 1
                            ? '快递'
                            : item == 2
                              ? '同城'
                              : item == 3
                                ? '自提'
                                : '点餐'}
                        </span>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            <div className="payment-record">
              <img
                className="goods-style-wechat"
                src="http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/goods-style-wechat.png"
              />
              <span className="payment-record-word">微信支付交易</span>
              <div className="pull-right">
                <div className="buyer-list">
                  {goodsInfo.buyer_list.map((item, index) => {
                    return (
                      <img
                        key={index}
                        src={
                          item.cover_thumb ||
                          'http://img.zhichiwangluo.com/zcimgdir/album/file_55910ef341577.png'
                        }
                      />
                    )
                  })}
                </div>
                <span
                  className="word-orange buy-number"
                  style={convertLineStyleData('color:' + storeStyle.theme)}
                >
                  {'购买' + goodsInfo.seckill_sales + '+'}
                </span>
                <span className="color-999">
                  {'浏览' + goodsInfo.viewed_count + '+'}
                </span>
              </div>
            </div>
            <div className="goods-recommend">
              <div className="recommend-header">
                <img
                  src={goodsInfo.app_cover}
                  className="store-picture"
                />
                <div className="store-des">{goodsInfo.app_name}</div>
                <div
                  className="pull-right go-to-store"
                  onClick={this.goToHomepage}
                >
                  进入店铺
                </div>
              </div>
              {!!goodsInfo.recommend_info.length && (
                <ScrollView className="recommend-content" scroll-x="true">
                  {goodsInfo.recommend_info.map((item, index) => {
                    return (
                      <div
                        className="recommend-goods"
                        key={item.form_data.id}
                        onClick={this.toRecommendGoodsDetail}
                        data-id={item.form_data.id}
                        data-goods-type={item.form_data.goods_type}
                      >
                        <div className="width-fix-image">
                          <img
                            mode="widthFix"
                            src={item.form_data.cover}
                          />
                        </div>
                        <div className="recommend-goods-title">
                          {item.form_data.title}
                        </div>
                        <span className="recommend-goods-price">
                          {'¥' + item.form_data.price}
                        </span>
                      </div>
                    )
                  })}
                </ScrollView>
             )}
            </div>
            <div style={convertLineStyleData('padding: 30rpx;text-align:center;color:#b2b2b2;font-size:24rpx;')}>
              <div className="line"></div>
              <div style={convertLineStyleData('display: inline-block;vertical-align:middle;margin:0 4px;')}>
                继续拖动，查看商品信息
              </div>
              <div className="line"></div>
            </div>
            <div className="detail-comment">
              <div className="detail-comment-menu">
                <div>
                  <span
                    data-type="detail"
                    onClick={this.oneSelectDetailCommet}
                    style={convertLineStyleData(
                      detailCommetType == 'detail'
                        ? 'color:' +
                        storeStyle.theme +
                        ';border-color:' +
                        storeStyle.theme
                        : ''
                    )}
                    className={detailCommetType == 'detail' ? 'active' : ''}
                  >
                    详情
                  </span>
                </div>
                <div>
                  <span
                    data-type="comment"
                    onClick={this.oneSelectDetailCommet}
                    style={convertLineStyleData(
                      detailCommetType == 'comment'
                        ? 'color:' +
                        storeStyle.theme +
                        ';border-color:' +
                        storeStyle.theme
                        : ''
                    )}
                    className={
                      'comment-num-box ' +
                      (detailCommetType == 'comment' ? 'active' : '')
                    }
                  >
                    评论
                    <span className="comment-num">
                      {commentNums[0] == 0 ? '' : commentNums[0]}
                    </span>
                  </span>
                </div>
              </div>
              {detailCommetType != 'comment' && (
                <div className="sub-detail">
                  <TaroParseTmpl
                    data={{ wxParseData: wxParseDescription.nodes }}
                  ></TaroParseTmpl>
                </div>
              )}
              {detailCommetType == 'comment' && (
                <div className="sub-comment">
                  <div className="comPage-wrap page">
                    <div className="comPage-top-section">
                      <div>
                        <label
                          onClick={this.clickCommentLabel}
                          data-type="0"
                          style={convertLineStyleData(
                            'background:' +
                            storeStyle.theme +
                            '33' +
                            (commnetType == 0
                              ? ';background:' + storeStyle.theme
                              : '')
                          )}
                          className={
                            'comPage-comment-label ' +
                            (commnetType == 0 ? 'active' : '')
                          }
                        >
                          全部
                        </label>
                        <label
                          onClick={this.clickCommentLabel}
                          data-type="1"
                          style={convertLineStyleData(
                            'background:' +
                            storeStyle.theme +
                            '33' +
                            (commnetType == 1
                              ? ';background:' + storeStyle.theme
                              : '')
                          )}
                          className={
                            'comPage-comment-label ' +
                            (commnetType == 1 ? 'active' : '')
                          }
                        >
                          好评 (
                          <label className="comPage-positive-comment">
                            {commentNums[1]}
                          </label>
                          )
                        </label>
                        <label
                          onClick={this.clickCommentLabel}
                          data-type="2"
                          style={convertLineStyleData(
                            'background:' +
                            storeStyle.theme +
                            '33' +
                            (commnetType == 2
                              ? ';background:' + storeStyle.theme
                              : '')
                          )}
                          className={
                            'comPage-comment-label ' +
                            (commnetType == 2 ? 'active' : '')
                          }
                        >
                          中评 (
                          <label className="comPage-neutral-comment">
                            {commentNums[2]}
                          </label>
                          )
                        </label>
                        <label
                          onClick={this.clickCommentLabel}
                          data-type="3"
                          style={convertLineStyleData(
                            'background:' +
                            storeStyle.theme +
                            '33' +
                            (commnetType == 3
                              ? ';background:' + storeStyle.theme
                              : '')
                          )}
                          className={
                            'comPage-comment-label ' +
                            (commnetType == 3 ? 'active' : '')
                          }
                        >
                          差评 (
                          <label className="comPage-negative-comment">
                            {commentNums[3]}
                          </label>
                          )
                        </label>
                        <label
                          onClick={this.clickCommentLabel}
                          data-type="4"
                          style={convertLineStyleData(
                            'background:' +
                            storeStyle.theme +
                            '33' +
                            (commnetType == 4
                              ? ';background:' + storeStyle.theme
                              : '')
                          )}
                          className={
                            'comPage-comment-label ' +
                            (commnetType == 4 ? 'active' : '')
                          }
                        >
                          有图 (
                          <label className="comPage-pic-comment">
                            {commentNums[4]}
                          </label>
                          )
                        </label>
                      </div>
                    </div>
                    <div
                      className="comPage-bottom-section"
                      hidden={displayComment}
                    >
                      <div className="comPage-comment-list">
                        {commentArr.map((item, index) => {
                          return (
                            <div className="comPage-comment-item" key={index}>
                              <div>
                                <img
                                  className="comPage-comment-photo"
                                  src={item.buyer_headimgurl}
                                />
                                <span className="comPage-comment-name">
                                  {item.buyer_nickname}
                                </span>
                              </div>
                              <span className="comPage-comment-date">
                                {item.add_time}
                              </span>
                              <div className="comPage-comment-content">
                                {item.assess_info.content}
                              </div>
                              {item.assess_info.has_img && (
                                <div className="comPage-comment-pics">
                                  {item.assess_info.img_arr.map(
                                    (imgSrc, index) => {
                                      return (
                                        <img
                                          key={index}
                                          src={imgSrc}
                                          data-src={imgSrc}
                                          data-srcarr={JSON.stringify(item.assess_info.img_arr)}
                                          onClick={this.clickPlusImages}
                                        />
                                      )
                                    }
                                  )}
                                </div>
                              )}
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className="no-comment" hidden={!displayComment}>
                      暂无评论
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {/*  模式2  */}
        {goodsInfo.detail_type == 2 && (
          <div className="goods-detail-content styleTwo">
            <div className="goods-header">
              <div className="goods-title">
                <span
                  className="ico-moon icon-seckill-alarm cover-icon-seckill-alarm"
                  style={convertLineStyleData('color:' + storeStyle.theme)}
                ></span>
                {goodsInfo.title}
              </div>
              <div className="goods-share">
                <div className="goods-price-line"></div>
                <div className="goods-price">
                  <div
                    className="share-goods"
                    onClick={this.showQRCodeComponent}
                  >
                    <span className="ico-moon icon-news-sharefriends"></span>
                  </div>
                </div>
              </div>
            </div>
            <div className="goods-coupon" onClick={this.toCouponList}>
              <span
                className="styleTwo-btn"
                style={convertLineStyleData(
                  'color:' +
                  storeStyle.theme +
                  ';border-color:' +
                  storeStyle.theme
                )}
              >
                优惠券
              </span>
              <span>领取优惠券</span>
              <span className="pull-right ico-moon icon-rightarrow"></span>
            </div>
            <div className="goods-freight">
              <span
                className="styleTwo-btn"
                style={convertLineStyleData(
                  'color:' +
                  storeStyle.theme +
                  ';border-color:' +
                  storeStyle.theme
                )}
              >
                运费
              </span>
              <span>{'运费' + (goodsInfo.express_fee || '包邮')}</span>
            </div>
            <div className="goods-freight">
              <label>取货方式</label>
              <div className="address-pick-up">
                {goodsInfo.pick_up_type.map((item, index) => {
                  return (
                    <div key={item}>
                      <span
                        style={convertLineStyleData('color:' + storeStyle.theme)}
                        className="ico-moon icon-goods-support-delivery suporrt"
                      ></span>
                      <span>
                        {item == 1
                          ? '快递'
                          : item == 2
                            ? '同城'
                            : item == 3
                              ? '自提'
                              : '点餐'}
                      </span>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="goods-comment" hidden={displayComment}>
              <div className="comment-title">
                <div className="goods-comment-title">
                  {'用户怎么说 (' + (commentNums[0] || 0) + ')'}
                </div>
                <div className="go-to-comment" onClick={this.goToCommentPage}>
                  查看全部
                </div>
              </div>
              <div className="block-item">
                <ScrollView className="comPage-comment-list" scroll-x="true">
                  {commentArr.map((item, index) => {
                    return (
                      <div className="comPage-comment-item" key={index}>
                        <div>
                          <img
                            className="comPage-comment-photo"
                            src={item.buyer_headimgurl}
                          />
                          <span className="comPage-comment-name">
                            {item.buyer_nickname}
                          </span>
                        </div>
                        <div className="comPage-comment-content">
                          {item.assess_info.content}
                        </div>
                      </div>
                    )
                  })}
                </ScrollView>
              </div>
            </div>
            <div className="goods-recommend">
              <div className="recommend-header">
                <img
                  src={goodsInfo.app_cover}
                  className="store-picture"
                />
                <div className="store-name">{goodsInfo.app_name}</div>
                <div
                  className="pull-right go-to-store"
                  onClick={this.goToHomepage}
                >
                  进入店铺
                </div>
              </div>
            </div>
            <div style={convertLineStyleData('padding: 30rpx;text-align:center;color:#b2b2b2;font-size:24rpx;')}>
              <div className="line"></div>
              <div style={convertLineStyleData('display: inline-block;vertical-align:middle;margin:0 4px;')}>
                继续拖动，查看商品信息
              </div>
              <div className="line"></div>
            </div>
            <div className="goods-detail-section">
              <div className="comment-title">
                <div style={convertLineStyleData('border-bottom: 1px solid #f4f4f4;padding-bottom:20rpx;')}>
                  商品详情
                </div>
              </div>
              <div className="goods-details rich-text" dangerouslySetInnerHTML={{ __html: goodsInfo.description && goodsInfo.description.replace(/href=".*?"/g,'') }}></div>
            </div>
            {!!goodsInfo.recommend_info.length && (
              <div className="goods-recommend">
                <div className="two-recommend">店铺推荐</div>
                <ScrollView className="recommend-content" scroll-x="true">
                  {goodsInfo.recommend_info.map((item, index) => {
                    return (
                      <div
                        className="recommend-goods"
                        key={item.form_data.id}
                        onClick={this.toRecommendGoodsDetail}
                        data-id={item.form_data.id}
                        data-goods-type={item.form_data.goods_type}
                      >
                        <div className="width-fix-image">
                          <img
                            mode="widthFix"
                            src={item.form_data.cover}
                          />
                        </div>
                        <div className="recommend-goods-title">
                          {item.form_data.title}
                        </div>
                        <span className="recommend-goods-price">
                          {'¥' + item.form_data.price}
                        </span>
                      </div>
                    )
                  })}
                </ScrollView>
              </div>
            )}
          </div>
        )}
        {goodsInfo.detail_type == 2 && (
          <div className="goods-bottom-two">
            <div className="bottom-two-left">
              <div>
                <div className="ico-moon icon-service2">
                  {/* <ContactButton
                    type="default-dark"
                    size="20"
                    sessionFrom={sessionFrom}
                  ></ContactButton> */}
                </div>
                <div>客服</div>
              </div>
              {!franchiseeId && (
                <div className="form-two-contain">
                  <form>
                    <button type="button" onClick={goodsInfo.is_favorite == 1 ? this.deleteFavoriteGoods : this.addFavoriteGoods}>
                      <span
                        style={convertLineStyleData(
                          goodsInfo.is_favorite == 1
                            ? 'color:' + storeStyle.theme
                            : ''
                        )}
                        className={
                          'ico-moon icon-' +
                          (goodsInfo.is_favorite == 1
                            ? 'collect-solid'
                            : 'goods-detail-favorites')
                        }
                      ></span>
                      <div>收藏</div>
                    </button>
                  </form>
                </div>
              )}
              <div onClick={this.goToShoppingCart}>
                <span className="ico-moon icon-new-goods-shopping"></span>
                <div>购物车</div>
              </div>
            </div>
            <div className="bottom-two-right">
              {goodsInfo.seckill_progress != 100 &&
                goodsInfo.seckill_start_state != 2 && (
                  <label
                    className="add-to-shoppingCart"
                    style={convertLineStyleData(
                      'border-color:' +
                      storeStyle.theme +
                      ';color:' +
                      storeStyle.theme
                    )}
                    onClick={this.showAddToShoppingCart}
                  >
                    加入购物车
                  </label>
                )}
              {goodsInfo.seckill_progress != 100 &&
                goodsInfo.seckill_start_state == 1 && (
                  <label
                    className="buy-goods-directly"
                    style={convertLineStyleData('background:' + storeStyle.theme)}
                    onClick={this.showBuyDirectly}
                  >
                    立即购买
                  </label>
                )}
              {goodsInfo.seckill_start_state == 0 &&
                goodsInfo.is_seckill_activity_care == 0 && (
                  <form>
                    <button
                      type="button"
                      className="form-button"
                      data-goods={JSON.stringify(goodsInfo)}
                      data-is_deleted="0"
                      onClick={this.formSubmitRemind}>
                      <label
                        className="buy-goods-directly"
                        style={convertLineStyleData('background:' + storeStyle.theme)}
                      >
                        设置提醒
                      </label>
                    </button>
                  </form>
                )}
              {goodsInfo.seckill_start_state == 0 &&
                goodsInfo.is_seckill_activity_care == 1 && (
                  <form>
                    <button
                      type="button"
                      className="form-button"
                      onClick={this.formSubmitRemind}
                      data-goods={JSON.stringify(goodsInfo)}
                      data-is_deleted="1">
                      <label
                        className="buy-goods-directly"
                        style={convertLineStyleData('background:' + storeStyle.theme)}
                      >
                        取消提醒
                      </label>
                    </button>
                  </form>
                )}
              {/*  <label class="buy-goods-directly" style={convertLineStyleData('{{ 'background:' + storeStyle.theme }}')} catchtap="showBuyDirectly">取消提醒</label>  */}
              {goodsInfo.seckill_progress == 100 &&
                goodsInfo.seckill_start_state == 1 && (
                  <label className="buy-goods-directly buy-goods-directly-over">
                    商品已抢光
                  </label>
                )}
              {goodsInfo.seckill_start_state == 2 && (
                <label className="buy-goods-directly buy-goods-directly-over">
                  活动已结束
                </label>
              )}
            </div>
          </div>
        )}
        <div
          id="payDialog"
          className="page-dialog-wrap"
          hidden={addToShoppingCartHidden}
        >
          <div className="page-bottom-dialog">
            <div
              className="pay-close-dialog page-dialog-close"
              onClick={this.hiddeAddToShoppingCart}
            >
              <span className="ico-moon icon-closes"></span>
            </div>
            <div className="dialog-goods-header">
              <div className="thumb">
                <div className="thumb-wrap">
                  <img
                    data-src={selectModelInfo.imgurl || goodsInfo.cover}
                    onClick={this.clickPlusImages}
                    className="pay-goods-cover"
                    src={selectModelInfo.imgurl || goodsInfo.cover}
                  />
                </div>
              </div>
              <div className="pay-goods-baseinfo">
                <div className="pay-goods-price">
                  <div className="pay-current-price">
                    <span
                      style={convertLineStyleData('font-size:28rpx;')}
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                    >
                      {'¥' + selectModelInfo.price}
                    </span>
                    {isShowVirtualPrice &&
                      selectModelInfo.virtualPrice != 0 && (
                        <span className="virtualPrice">
                          {'¥' + selectModelInfo.virtualPrice}
                        </span>
                      )}
                  </div>
                </div>
                <div className="pay-goods-stock">
                  {'库存 ' + selectModelInfo.stock}
                </div>
                {selectModelInfo.models_text && (
                  <div className="pay-checked-text clearfix">
                    {'已选：' + selectModelInfo.models_text}
                  </div>
                )}
              </div>
            </div>
            <div className="payDialog-content">
              <div
                className="pay-goods-models"
                hidden={!(goodsInfo.model_items && goodsInfo.model_items.length)}
              >
                {goodsInfo.model && goodsInfo.model.map((model, modelIndex) => {
                  return (
                    <div key={modelIndex}>
                      <span className="model-title">{model.name}</span>
                      <label className="pills-list">
                        {model.subModelName.map((name, index) => {
                          return (
                            <label
                              key={index}
                              data-model-index={modelIndex}
                              data-submodel-index={index}
                              className={
                                'subModel ' +
                                (selectModelInfo.models[modelIndex] ==
                                  model.subModelId[index]
                                  ? 'select'
                                  : '')
                              }
                              data-submodel-id={model.subModelId[index]}
                              onClick={this.selectSubModel}
                              style={convertLineStyleData(
                                selectModelInfo.models[modelIndex] ==
                                  model.subModelId[index]
                                  ? 'background:' + storeStyle.theme
                                  : ''
                              )}
                            >
                              {name}
                            </label>
                          )
                        })}
                      </label>
                    </div>
                  )
                })}
              </div>
              <div
                className="payDialog-buy-num"
                style={convertLineStyleData('padding-left:10px;padding-right:10px;')}
              >
                <div className="clearfix">
                  <span>购买数量</span>
                  <span className="buy-limit">
                    {'(限购' + goodsInfo.seckill_buy_limit + '件)'}
                  </span>
                  <div className="pull-right">
                    <div className="quantity pull-left">
                      <label
                        className={
                          'minus ' +
                          (selectModelInfo.buyCount <= 1 ? 'disabled' : '')
                        }
                      ></label>
                      <input
                        className="pay-buy-count"
                        type="number"
                        className="txt"
                        value={selectModelInfo.buyCount}
                        onChange={this.inputBuyCount}
                      />
                      <label
                        className={
                          'plus ' +
                          (selectModelInfo.buyCount >= selectModelInfo.stock ||
                            selectModelInfo.buyCount >=
                            goodsInfo.seckill_buy_limit
                            ? 'disabled'
                            : '')
                        }
                      ></label>
                      <div
                        className="response-area response-area-minus"
                        onClick={this.clickMinusButton}
                      ></div>
                      <div
                        className="response-area response-area-plus"
                        onClick={this.clickPlusButton}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="dialog-bottom">
              <div hidden={ifAddToShoppingCart}>
                <div
                  style={convertLineStyleData('background:' + storeStyle.theme)}
                  className="btn-orange pay-buy-next"
                  onClick={this.buyDirectlyNextStep}
                >
                  下一步
                </div>
              </div>
              <div hidden={!ifAddToShoppingCart}>
                <div
                  style={convertLineStyleData('background:' + storeStyle.theme)}
                  className="pay-add-to-shoppingcart"
                  onClick={this.sureAddToShoppingCart}
                >
                  加入购物车
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/seckill-detail/SeckillDetail.jsx